// extracted by mini-css-extract-plugin
export default {"wrapper":"XCkka","mobile":"P16Qe","icon":"yz1DO","button":"u9J8U"};